// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 07-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import StaffActionTypes from './staff.types';

import {
	staffDetailsAdd,
	staffDetailsUpdate,
	staffListGet,
	staffDetailsFetch,
	staffDetailsDelete,
	staffPublishStatusUpdate,
	staffIsPrintStatusUpdate,
	getAllStaffDetails,
} from './staff.service';

import {
	addStaffDetailsSuccess,
	addStaffDetailsFailure,
	addStaffDetailsResponseChanged,
	updateStaffDetailsSuccess,
	updateStaffDetailsFailure,
	updateStaffDetailsResponseChanged,
	getStaffListSuccess,
	getStaffListFailure,
	getStaffListResponseChanged,
	fetchStaffDetailsSuccess,
	fetchStaffDetailsFailure,
	fetchStaffDetailsResponseChanged,
	deleteStaffDetailsSuccess,
	deleteStaffDetailsFailure,
	deleteStaffDetailsResponseChanged,
	updateIsPublishStatusSuccess,
	updateIsPublishStatusFailure,
	updateIsPublishStatusResponseChanged,
	updateIsPrintStaffSuccess,
	updateIsPrintStaffFailure,
	updateIsPrintStaffResponseChanged,
	getAllStaffFailure,
	getAllStaffSuccess,
	getAllStaffResponseChanged,
} from './staff.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET STAFF LIST  ******************** */
export function* staffDetailsListGet({ payload }: any) {
	const {
		companyID,
		userID,
		userRole,
		userLevel,
		userAccessBranchID,
		inputSearch,
		limit,
		databaseName,
		userRoleID,
	} = payload;
	try {
		const key = 'GetStaffListKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRoleName: userRole,
			Level: userLevel,
			BranchID: userAccessBranchID ?? '0',
			SearchData: inputSearch,
			Limit: limit,
			DatabaseName: databaseName,
			staffLevel: userRoleID,
			staffRoleName: userRoleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getStaffListFailure(responseData.data));
		} else {
			yield put(getStaffListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getStaffListFailure(error));
	}
}

export function* resetGetStaffListResponse() {
	yield put(getStaffListResponseChanged());
}

export function* onGetStaffListDetails() {
	yield takeLatest(StaffActionTypes.GET_STAFF_LIST_START, staffDetailsListGet);
}

export function* onGetStaffListResponseReset() {
	yield takeLatest(StaffActionTypes.GET_STAFF_LIST_RESPONSE_RESET, resetGetStaffListResponse);
}
/** *********************  END GET STAFF LIST ******************** */

/** *********************  START UPDATE STAFF IS PUBLISH STATUS DETAILS  ******************** */
export function* staffIsPublishUpdate({ payload }: any) {
	const { staffID, isPublish, databaseName, userName, userID, companyID, BranchID } = payload;
	try {
		const key = 'UpdateStaffPublisKey';
		const jsonData = {
			StaffID: staffID,
			IsPublish: isPublish,
			DatabaseName: databaseName,
			UserType: 'Staff',
			UserName: userName,
			CreatedBy: userID,
			CompanyID: companyID,
			BranchID: BranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffPublishStatusUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateIsPublishStatusFailure(responseData.data));
		} else {
			yield put(updateIsPublishStatusSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateIsPublishStatusFailure(error));
	}
}

export function* resetUpdatePublishStatusResponse() {
	yield put(updateIsPublishStatusResponseChanged());
}

export function* onUpdatePublishStatus() {
	yield takeLatest(StaffActionTypes.UPDATE_ISPUBLISH_STATUS_START, staffIsPublishUpdate);
}

export function* onUpdatePublishStatusResponseReset() {
	yield takeLatest(
		StaffActionTypes.UPDATE_ISPUBLISH_STATUS_RESPONSE_RESET,
		resetUpdatePublishStatusResponse,
	);
}
/** *********************  END UPDATE STAFF IS PUBLISH STATUS DETAILS ******************** */

/** *********************  START DELETE STAFF DETAILS  ******************** */
export function* staffDelete({ payload }: any) {
	const { companyID, staffID, staffName, databaseName, userID, userAccessBranchID, userName } =
		payload;
	try {
		const key = 'DeleteStaffDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			StaffID: staffID,
			UserName: staffName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID ?? '0',
			UserAccessName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteStaffDetailsFailure(responseData.data));
		} else {
			yield put(deleteStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteStaffDetailsFailure(error));
	}
}

export function* resetDeleteStaffDetailsResponse() {
	yield put(deleteStaffDetailsResponseChanged());
}

export function* onDeleteStaffDetail() {
	yield takeLatest(StaffActionTypes.DELETE_STAFF_DETAILS_START, staffDelete);
}

export function* onDeleteStaffResponseReset() {
	yield takeLatest(
		StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_RESET,
		resetDeleteStaffDetailsResponse,
	);
}
/** *********************  END DELETE STAFF DETAILS ******************** */

/** *********************  START ADD STAFF DETAILS  ******************** */
export function* createStaff({ payload }: any) {
	const {
		staffImage,
		staffUniqueID,
		staffName,
		staffPhoneNumber,
		staffEmailID,
		staffPassword,
		staffDateOfBirth,
		staffDateOfJoining,
		staffGender,
		staffDesignation,
		staffAddress,
		staffOfficeField,
		emergenceContactName1,
		emergenceContactPhone1,
		relationshipContact1,
		emergenceContactName2,
		emergenceContactPhone2,
		relationshipContact2,
		staffAlternativePhone,
		staffRoleID,
		staffBranchID,
		isGenerateConsumerReport,
		companyID,
		generalCompanyID,
		databaseName,
		userName,
		userAccessBranchID,
		userID,
		branchCityID,
		branchStateID,
		staffEducation,
		SelectedLevel,
	} = payload;
	try {
		const key = 'AddStaffDetailKey';
		const stafflistJson = JSON.stringify(payload.staffDetailArr).replace(/"/g, "'");
		const jsonData = {
			UserPhoto: staffImage ? staffImage : '',
			UniqueID: staffUniqueID,
			UserName: staffName,
			UserPhoneNumber: staffPhoneNumber,
			UserEmailID: staffEmailID,
			UserPassword: staffPassword,
			DOB: staffDateOfBirth ? staffDateOfBirth : '0000-00-00',
			DateOfJoining: staffDateOfJoining,
			Sex: staffGender,
			Designation: staffDesignation,
			UserAddress: staffAddress,
			Office: staffOfficeField,
			EmergencyContactNameOne: emergenceContactName1,
			EmergencyNumberOne: emergenceContactPhone1,
			EmergencyRelationShipOne: relationshipContact1,
			EmergencyContactNameTwo: emergenceContactName2,
			EmergencyNumberTwo: emergenceContactPhone2,
			EmergencyRelationShipTwo: relationshipContact2,
			AlternativePhoneNumber: staffAlternativePhone,
			RoleID: staffRoleID ? staffRoleID : '',
			BranchID: staffBranchID,
			isConsumerReportStaff: isGenerateConsumerReport ? 1 : 0,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			DatabaseName: databaseName,
			UserAccessName: userName,
			UserAccessBranchID: userAccessBranchID ?? '0',
			CreatedBy: userID,
			UserLocation: stafflistJson,
			InvestorDetails: '',
			EmployeeCode: '',
			AccountArr: '',
			UserCity: branchCityID,
			UserState: branchStateID,
			UserEducation: staffEducation,
			UserLevel: SelectedLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addStaffDetailsFailure(responseData.data));
		} else {
			yield put(addStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addStaffDetailsFailure(error));
	}
}

export function* resetAddStaffResponse() {
	yield put(addStaffDetailsResponseChanged());
}

export function* onCreateStaffDetails() {
	yield takeLatest(StaffActionTypes.ADD_STAFF_DETAILS_START, createStaff);
}

export function* onCreateStaffResponseReset() {
	yield takeLatest(StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_RESET, resetAddStaffResponse);
}
/** *********************  END ADD STAFF DETAILS ******************** */

/** *********************  START FETCH STAFF DETAILS  ******************** */
export function* fetchStaffData({ payload }: any) {
	const { companyID, staffID, databaseName, userLevel } = payload;
	try {
		const key = 'FetchStaffDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			StaffID: staffID,
			DatabaseName: databaseName,
			Level: userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchStaffDetailsFailure(responseData.data));
		} else {
			yield put(fetchStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchStaffDetailsFailure(error));
	}
}

export function* resetFetchStaffDetailsResponse() {
	yield put(fetchStaffDetailsResponseChanged());
}

export function* onFetchStaffDetails() {
	yield takeLatest(StaffActionTypes.FETCH_STAFF_DETAILS_START, fetchStaffData);
}

export function* onFetchStaffResponseReset() {
	yield takeLatest(
		StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_RESET,
		resetFetchStaffDetailsResponse,
	);
}
/** *********************  END FETCH STAFF DETAILS ******************** */

/** *********************  START UPDATE STAFF DETAILS  ******************** */
export function* staffUpdate({ payload }: any) {
	const {
		staffImage,
		staffUniqueID,
		staffName,
		staffPhoneNumber,
		staffEmailID,
		staffPassword,
		staffDateOfBirth,
		staffDateOfJoining,
		staffGender,
		staffDesignation,
		staffAddress,
		staffOfficeField,
		emergenceContactName1,
		emergenceContactPhone1,
		relationshipContact1,
		emergenceContactName2,
		emergenceContactPhone2,
		relationshipContact2,
		staffAlternativePhone,
		staffRoleID,
		staffBranchID,
		isGenerateConsumerReport,
		companyID,
		generalCompanyID,
		databaseName,
		userName,
		userAccessBranchID,
		userID,
		branchCityID,
		branchStateID,
		staffEducation,
		SelectedLevel,
		staffID,
	} = payload;
	try {
		const key = 'UpdateStaffDetailsKey';
		const stafflistJson = JSON.stringify(payload.staffDetailArr).replace(/"/g, "'");
		const jsonData = {
			UserPhoto: staffImage,
			UniqueID: staffUniqueID,
			UserName: staffName,
			UserPhoneNumber: staffPhoneNumber,
			UserEmailID: staffEmailID,
			UserPassword: staffPassword,
			DateOfBirth: staffDateOfBirth,
			DateOfJoining: staffDateOfJoining,
			Gender: staffGender,
			Designation: staffDesignation,
			Address: staffAddress,
			Office: staffOfficeField,
			EmergencyContactNameOne: emergenceContactName1,
			EmergencyNumberOne: emergenceContactPhone1,
			EmergencyRelationshipOne: relationshipContact1,
			EmergencyContactNameTwo: emergenceContactName2,
			EmergencyNumberTwo: emergenceContactPhone2,
			EmergencyRelationshipTwo: relationshipContact2,
			AlternativePhoneNumber: staffAlternativePhone,
			RoleID: staffRoleID,
			BranchID: staffBranchID,
			IsConsumerReportStaff: isGenerateConsumerReport ? 1 : 0,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			DatabaseName: databaseName,
			UserAccessName: userName,
			UserAccessBranchID: userAccessBranchID ?? '0',
			CreatedBy: userID,
			UserLocation: stafflistJson,
			InvestorDetails: '',
			EmployeeCode: '',
			AccountArr: '',
			UserCity: branchCityID,
			UserState: branchStateID,
			UserEducation: staffEducation,
			UserLevel: SelectedLevel,
			UserID: staffID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateStaffDetailsFailure(responseData.data));
		} else {
			yield put(updateStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateStaffDetailsFailure(error));
	}
}

export function* resetUpdateStaffDetailsResponse() {
	yield put(updateStaffDetailsResponseChanged());
}

export function* onUpdateStaffDetails() {
	yield takeLatest(StaffActionTypes.UPDATE_STAFF_DETAILS_START, staffUpdate);
}

export function* onUpdateStaffResponseReset() {
	yield takeLatest(
		StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_RESET,
		resetUpdateStaffDetailsResponse,
	);
}
/** *********************  END UPDATE STAFF DETAILS ******************** */

/** *********************  START UPDATE STAFF IS PRINT STATUS DETAILS  ******************** */
export function* staffIsPrintUpdate({ payload }: any) {
	const {
		UserID,
		isPrintReceiptAsManager,
		databaseName,
		companyID,
		userID,
		userName,
		staffBranchID,
		StaffLevel,
		BranchName,
	} = payload;
	try {
		const key = 'UpdateStaffIsPrintKey';
		const jsonData = {
			StaffID: UserID,
			IsPrintReceiptAsManager: isPrintReceiptAsManager,
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoginUserID: userID,
			LoginUserName: userName,
			StaffBranchID: staffBranchID,
			staffLevel: StaffLevel,
			BranchName: BranchName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(staffIsPrintStatusUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateIsPrintStaffFailure(responseData.data));
		} else {
			yield put(updateIsPrintStaffSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateIsPrintStaffFailure(error));
	}
}

export function* resetUpdateIsPrintStaffResponse() {
	yield put(updateIsPrintStaffResponseChanged());
}

export function* onUpdateIsPrintStaff() {
	yield takeLatest(StaffActionTypes.UPDATE_ISPRINT_STAFF_START, staffIsPrintUpdate);
}

export function* onUpdateIsPrintStaffResponseReset() {
	yield takeLatest(
		StaffActionTypes.UPDATE_ISPRINT_STAFF_RESPONSE_RESET,
		resetUpdateIsPrintStaffResponse,
	);
}
/** *********************  END UPDATE STAFF IS PRINT STATUS DETAILS ******************** */

export function* staffDetailsGetAll({ payload }: any) {
	const {
		companyID,
		userID,
		userRole,
		userLevel,
		userAccessBranchID,
		inputSearch,
		databaseName,
		userRoleID,
	} = payload;
	try {
		const key = 'GetAllStaffKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRoleName: userRole,
			Level: userLevel,
			BranchID: userAccessBranchID ?? '0',
			SearchData: inputSearch,
			DatabaseName: databaseName,
			staffLevel: userRoleID,
			staffRoleName: userRoleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllStaffDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllStaffFailure(responseData.data));
		} else {
			yield put(getAllStaffSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllStaffFailure(error));
	}
}

export function* resetGetAllStaffResponse() {
	yield put(getAllStaffResponseChanged());
}

export function* onGetAllStaffDetails() {
	yield takeLatest(StaffActionTypes.GET_ALL_STAFF_START, staffDetailsGetAll);
}

export function* onGetAllStaffResponseReset() {
	yield takeLatest(StaffActionTypes.GET_ALL_STAFF_RESPONSE_RESET, resetGetAllStaffResponse);
}

export function* staffMasterSaga() {
	yield all([
		call(onCreateStaffDetails),
		call(onCreateStaffResponseReset),
		call(onUpdateStaffDetails),
		call(onUpdateStaffResponseReset),
		call(onGetStaffListDetails),
		call(onGetStaffListResponseReset),
		call(onFetchStaffDetails),
		call(onFetchStaffResponseReset),
		call(onDeleteStaffDetail),
		call(onDeleteStaffResponseReset),
		call(onUpdatePublishStatus),
		call(onUpdatePublishStatusResponseReset),
		call(onUpdateIsPrintStaff),
		call(onUpdateIsPrintStaffResponseReset),
		call(onGetAllStaffDetails),
		call(onGetAllStaffResponseReset),
	]);
}
